export default "__VITE_ASSET__DMil3TnK__"